import React from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, IconButton, Skeleton, Typography } from '@mui/material';
import { useCopyToClipboard } from '../../../components/useCopyToClipboard';

interface VersionRowProps {
  label: string;
  value?: string;
  isLoading?: boolean;
}

export const VersionRow: React.FC<VersionRowProps> = ({ label, value, isLoading }) => {
  const copy = useCopyToClipboard();

  if (isLoading) {
    return (
      <Box sx={{ mb: 1, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <Typography sx={{ mr: 1 }} fontWeight="bold">
          {label}:
        </Typography>
        <Skeleton width={120} />
      </Box>
    );
  }

  const displayValue = value ? value : 'unknown';

  return (
    <Box sx={{ mb: 1, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Typography sx={{ mr: 1 }} fontWeight="bold">
        {label}:
      </Typography>
      <Typography
        sx={{
          cursor: value ? 'pointer' : 'default',
          pl: 0.5,
          pr: 0.5,
          '&:hover': value
            ? {
                background: 'grey',
                color: 'secondary.contrastText',
              }
            : undefined,
        }}
        onClick={value ? () => copy(displayValue) : undefined}
      >
        {displayValue}
      </Typography>
      {value && (
        <IconButton onClick={() => copy(displayValue)} sx={{ ml: 0.5 }} size="small">
          <ContentCopyIcon color="action" fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};
